// Generated by GitHub Copilot
import { useTranslation } from 'react-i18next'
import type Account from '#core/entities/auth/accounts/Account.ts'
import { ConfirmModal } from '#components/primitives/components/confirm-modal.tsx'
import type { LinkedAccountsState } from './linked-accounts-state.ts'
import { mapLinkedAccountLabel } from './linked-account-label.ts'

interface LinkedAccountRemoveDialogProps {
  account: Account | null
  /** The account this session signed in with: removing it ends the session, so the user is signed out. */
  isCurrent: boolean
  state: LinkedAccountsState
  onClose: () => void
}

/** Confirms removing one of the user's sign-in accounts. */
export function LinkedAccountRemoveDialog({ account, isCurrent, state, onClose }: LinkedAccountRemoveDialogProps) {
  const { t } = useTranslation('settings')
  const label = account ? mapLinkedAccountLabel(account, t) : null

  return (
    <ConfirmModal
      isOpen={account !== null}
      title={t('security.linkedAccounts.removeDialog.title')}
      message={t('security.linkedAccounts.removeDialog.message', { account: label ? `${label.title} (${label.detail})` : '' })}
      warning={isCurrent && t('security.linkedAccounts.removeDialog.currentWarning')}
      confirmLabel={t('shared.actions.remove')}
      cancelLabel={t('shared.actions.cancel')}
      genericErrorLabel={t('security.linkedAccounts.removeDialog.error')}
      onClose={onClose}
      onConfirm={async () => {
        if (!account) return
        await state.remove(account)
        if (isCurrent && !state.lastAccountRefused) window.location.assign('/logout')
      }}
    />
  )
}
